import React from "react";
import { usersLogOut } from "../../../api/api";
import useApi from "../../../hooks/useApi";
import { useSession } from "../../../state/api/session/useSession";
import { Cookies, deleteCookie } from "../../../util/cookies";
import Button from "../buttons/Button";
import Icon from "../icons/Icon";
import "./LogOutButton.css";
import { generateClassName } from "../../../hooks/useAttributes";

interface Props {
  withText: boolean
}

export default function LogOutButton(props: Props) {

  const { withText } = props;

  const { session, mutate } = useSession();

  const callApi = useApi();

  const clickHandler = async () => {
    await callApi(usersLogOut());
    await mutate();

    deleteCookie(Cookies.Session);

  }

  return (
    <div className="log-out d-flex flex-row align-items-center" onClick={clickHandler}>
      <div className="log-out-icon d-flex justify-content-center">
        <Button color="#F05353" icon="power" iconSize={16} />
      </div>

      <div className={generateClassName("d-none log-out-text flex-column overflow-hidden gap-0", {
        value: withText,
        onTrue: "log-out-text-visible"
      })}>
        <strong className="transition text-uppercase sidenav-link-label font-code">Log out</strong>
        {session.email && (
          <span className="sidenav-link-description font-s text-truncate m-0 p-0 email">{session.email}</span>
        )}
      </div>
    </div>
  )
}